import React from 'react';
import 'react-dom';
import '../../_rollupPluginBabelHelpers-2e5b701d.js';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';
import '../../index-930c2100.js';
import '../../hooks/useActivify.js';
import '../../index-efb29065.js';
import '../../key_codes-a5a2b85e.js';
import '@styled-system/space';
import '@styled-system/color';
import '@styled-system/border';
import '@styled-system/variant';
import '@styled-system/typography';
import '../../style-inject.es-1f59c1d0.js';
import '@styled-system/layout';
import '@styled-system/flexbox';
import '@styled-system/position';
import '@styled-system/shadow';
import '../box.js';
import { g as getObjectValue } from '../../util-cc00ee1d.js';
import '../../index.esm-f8e9e79f.js';
import '@styled-system/grid';
import '@styled-system/background';
import { I as IconWrapper } from '../../IconWrapper-eb05d1ed.js';

var ArrowsUpRightIcon = function ArrowsUpRightIcon(props) {
  return /*#__PURE__*/React.createElement(IconWrapper, props, /*#__PURE__*/React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.8234 17.1633L21.8234 17.1633L21.8242 17.1651C21.9253 17.4113 21.9253 17.6874 21.8241 17.9335L21.8234 17.9354C21.7754 18.0591 21.7035 18.1722 21.6118 18.2682C21.6116 18.2685 21.6113 18.2687 21.6111 18.269L18.2791 21.6006L18.2788 21.6009C18.1848 21.6957 18.073 21.7709 17.9497 21.8222C17.8265 21.8736 17.6944 21.9 17.5609 21.9C17.4274 21.9 17.2952 21.8736 17.172 21.8222C17.0488 21.7709 16.9369 21.6957 16.8429 21.6009L16.8424 21.6003C16.7476 21.5064 16.6724 21.3945 16.621 21.2713C16.5697 21.1481 16.5433 21.016 16.5433 20.8825C16.5433 20.749 16.5697 20.6169 16.621 20.4937C16.6724 20.3705 16.7476 20.2586 16.8424 20.1646L16.8424 20.1646L18.2869 18.7314L18.4592 18.5604H18.2165H8.67154C7.81396 18.5604 6.99151 18.2197 6.38511 17.6134C5.77871 17.0071 5.43805 16.1847 5.43805 15.3272V5.78318V5.54045L5.26707 5.71274L3.83393 7.15684C3.8339 7.15688 3.83386 7.15692 3.83382 7.15696C3.64335 7.34735 3.38505 7.45431 3.11571 7.45431C2.98233 7.45431 2.85025 7.42804 2.72701 7.377C2.60378 7.32596 2.49181 7.25115 2.39749 7.15684C2.30317 7.06253 2.22836 6.95058 2.17732 6.82736C2.12627 6.70414 2.1 6.57207 2.1 6.4387C2.1 6.16935 2.20701 5.91103 2.39749 5.72056L5.7302 2.38817C5.8262 2.29647 5.93932 2.22458 6.06312 2.17658L6.06312 2.1766L6.06497 2.17584C6.31115 2.07472 6.58728 2.07472 6.83346 2.17584L6.83345 2.17586L6.83531 2.17658C6.9591 2.22458 7.07222 2.29647 7.16822 2.38817L10.5009 5.72056L10.5012 5.72085C10.596 5.81485 10.6712 5.92667 10.7226 6.04988C10.7739 6.17308 10.8003 6.30523 10.8003 6.4387C10.8003 6.57217 10.7739 6.70433 10.7226 6.82753C10.6712 6.95074 10.596 7.06256 10.5012 7.15655L10.5006 7.15713C10.4066 7.2519 10.2948 7.32712 10.1716 7.37845C10.0484 7.42978 9.9162 7.45621 9.78271 7.45621C9.64922 7.45621 9.51706 7.42978 9.39384 7.37845C9.27062 7.32712 9.15878 7.2519 9.06478 7.15713L9.06476 7.15712L7.63136 5.71274L7.46038 5.54045V5.78318V15.3272C7.46038 15.6484 7.58799 15.9564 7.81512 16.1835C8.04226 16.4107 8.35033 16.5383 8.67154 16.5383H18.2165H18.4592L18.2869 16.3673L16.8427 14.9343C16.8426 14.9342 16.8426 14.9342 16.8425 14.9341C16.6521 14.7437 16.5452 14.4854 16.5452 14.2161C16.5452 13.9468 16.6522 13.6885 16.8427 13.498C17.0331 13.3075 17.2915 13.2005 17.5609 13.2005C17.8303 13.2005 18.0886 13.3075 18.2791 13.498L21.6111 16.8296C21.6113 16.8299 21.6116 16.8301 21.6118 16.8304C21.7035 16.9264 21.7754 17.0395 21.8234 17.1633Z",
    fill: getObjectValue(props.theme.colors, props.iconColor, props.theme.colors.grey.deep),
    stroke: getObjectValue(props.theme.colors, props.iconColor, props.theme.colors.black.pastel),
    strokeWidth: "0.2"
  })));
};
ArrowsUpRightIcon.propTypes = {
  iconColor: PropTypes.string
};
ArrowsUpRightIcon.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ArrowsUpRightIcon",
  "props": {
    "iconColor": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    }
  }
};
var ArrowsUpRightIcon$1 = withTheme(ArrowsUpRightIcon);

export default ArrowsUpRightIcon$1;
